/* Créée par Incipit Studio — voitures fixes, changement discret */
if(!customElements.get('kaarz-car-showcase')){
 customElements.define('kaarz-car-showcase',class extends HTMLElement{
  connectedCallback(){
   this.controller=new AbortController();this.slides=[...this.querySelectorAll('[data-car-slide]')];this.index=0;
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.mobile=matchMedia('(max-width:749px)');
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:.05});this.observer.observe(this);
   this.timer=setInterval(()=>this.advance(),Number(this.dataset.interval)||1000);
   if(window.Shopify?.designMode){
    document.addEventListener('shopify:block:select',e=>{
     const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);
     if(i>=0){this.editorSelected=true;this.activate(i);}
    },{signal:this.controller.signal});
    document.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false;},{signal:this.controller.signal});
   }
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearInterval(this.timer);}
  async advance(){
   if(this.busy||this.editorSelected||!this.visible||document.hidden||this.reduced.matches||this.slides.length<2)return;
   this.busy=true;try{await this.activate((this.index+1)%this.slides.length);}finally{this.busy=false;}
  }
  async activate(i){
   const token=this.activation=(this.activation||0)+1;
   const next=this.slides[i];if(!next)return;
   next.querySelectorAll('[data-srcset]').forEach(el=>{el.srcset=el.dataset.srcset;delete el.dataset.srcset;});
   const img=next.querySelector('img');if(img.dataset.src){img.src=img.dataset.src;delete img.dataset.src;}
   try{await img.decode();}catch(_){return;}
   if(!this.isConnected||token!==this.activation)return;
   this.slides.forEach((slide,index)=>slide.classList.toggle('is-current',index===i));this.index=i;
  }
 });
}
